<template>
    <HeaderComponent/>
    <router-view></router-view>
  </template>

<script>
import HeaderComponent from '@/components/utils/HeaderComponent.vue'
export default {
    name: 'App',
      components: {
    HeaderComponent,
  },
  data() {
      return {
        name: 'Tom',
        age: 36
      }
    },
  
  methods:
  {
   
  }
}
</script>

<style>
  .midori-like {
    font-family: 'Roboto', Helvetica, Arial, sans-serif;
    font-weight: 500;
  }


#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 1px;
  margin-left: auto;
  margin-right: auto;
  /* width: 1400px; */
    
}
</style>
